/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateDocumentFolderRequestDocumentFolder,
  CreateDocumentFolderRequestDocumentFolderFromJSON,
  CreateDocumentFolderRequestDocumentFolderFromJSONTyped,
  CreateDocumentFolderRequestDocumentFolderToJSON
} from './CreateDocumentFolderRequestDocumentFolder'

/**
 *
 * @export
 * @interface CreateDocumentFolderRequest
 */
export interface CreateDocumentFolderRequest {
  /**
   *
   * @type {CreateDocumentFolderRequestDocumentFolder}
   * @memberof CreateDocumentFolderRequest
   */
  documentFolder: CreateDocumentFolderRequestDocumentFolder
}

export function CreateDocumentFolderRequestFromJSON(json: any): CreateDocumentFolderRequest {
  return CreateDocumentFolderRequestFromJSONTyped(json, false)
}

export function CreateDocumentFolderRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateDocumentFolderRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    documentFolder: CreateDocumentFolderRequestDocumentFolderFromJSON(json['document_folder'])
  }
}

export function CreateDocumentFolderRequestToJSON(value?: CreateDocumentFolderRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    document_folder: CreateDocumentFolderRequestDocumentFolderToJSON(value.documentFolder)
  }
}
